import React from 'react';
import { Flag, Gauge, Wrench } from 'lucide-react';
import { useI18n } from '../../../i18n';

export default function MobileKartLifeNote() {
  const { t } = useI18n();
  return (
    <aside className="login-kartlife-note" aria-labelledby="login-kartlife-note-title">
      <div className="login-kartlife-note-brand">
        <img src="/images/kartlife/brand/kartlife-mark-kl-v2.png" alt="" width="40" height="40" />
        <h2 id="login-kartlife-note-title">Kart<span>Life</span></h2>
        <span>{t('loginMobile.inMyKart')}</span>
      </div>
      <p>{t('loginMobile.kartLifeHook')}</p>
      <ol>
        {[[Wrench, 'build'], [Gauge, 'develop'], [Flag, 'race']].map(([Icon, key]) => (
          <li key={key}><Icon size={13} aria-hidden="true"/>{t('loginMobile.' + key)}</li>
        ))}
      </ol>
    </aside>
  );
}
